export const MARKET: string = "MARKET";
export const MARKET_SUCCESS: string = "MARKET_SUCCESS";
export const MARKET_ERROR: string = "MARKET_ERROR";

export const LIVE_MARKETS: string = "LIVE_MARKETS";
export const LIVE_MARKETS_SUCCESS: string = "LIVE_MARKETS_SUCCESS";
